import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import './Header.css';

const Header = () => {
  const { currentUser, logout } = useUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="app-header">
      <div className="header-container">
        <div className="header-left">
          <div className="logo" onClick={() => navigate('/')}>
            <span className="logo-icon">🎬</span>
            <span className="logo-text">Choice Network</span>
          </div>
          <nav className="nav-menu">
            <a href="/dashboard">Dashboard</a>
            <a href="/upload">Upload</a>
            <a href="/investments">Investments</a>
            <a href="/analytics">Analytics</a>
          </nav>
        </div>
        
        <div className="header-right">
          {currentUser ? (
            <>
              <div className="user-info-header">
                <span className="user-name">{currentUser.name || currentUser.email}</span>
                <span className="user-role">{currentUser.role}</span>
              </div>
              <button onClick={handleLogout} className="logout-btn-header">
                Logout
              </button>
            </>
          ) : (
            <button onClick={() => navigate('/login')} className="login-btn-header">
              Login
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
